import { useEffect } from 'react'
import UserEventApi from '../api/UserEventApi'
import useAuth from './useAuth'
import { UserEventType } from '@finance-lab/utils/types'

const api = new UserEventApi()

export const useLogUserEvent = (eventType: UserEventType, eventDetails: Record<string, unknown> = {}) => {
    const { isAuthenticated } = useAuth()
    const eventDetailsStr = JSON.stringify(eventDetails) // Stringify to be used in useEffect

    useEffect(() => {
        if (!isAuthenticated) return

        if (eventType) {
            void (async () => {
                const eventName = eventType

                await api.logEvent(eventName, JSON.parse(eventDetailsStr))
            })()
        }
    }, [eventType, eventDetailsStr, isAuthenticated])
}
